import script from "./CardReservaPlazasLibres.vue?vue&type=script&setup=true&lang=js"
export * from "./CardReservaPlazasLibres.vue?vue&type=script&setup=true&lang=js"

import "./CardReservaPlazasLibres.vue?vue&type=style&index=0&id=336cc9f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336cc9f2"]])

export default __exports__